import {
    getAsync,
    postAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/Cycles";

// GET Cycles for current user paginated, filtered and sorted
export async function getCyclesForCurrentUserAsync(params) {

  var url = `${endpoint}/getCyclesForCurrentUser`;

  var payload = {
    userId: params.userId,
    page: params.page,
    size: params.size,
    sortBy: params.sortBy,
    sortDesc: params.sortDesc[0],
    searchParams: params.searchParams
  };

  return await postAsync(url, payload);
}

export async function getCycleAsync(Id) {
  return await getAsync(`${endpoint}/${Id}`);
}

export async function getCycleLightAsync(Id){
  return await getAsync(`${endpoint}/GetCycleLightById/${Id}`);
}

export async function AddOrUpdateCycleAsync(model) {
  return await postAsync(`${endpoint}/AddOrUpdateCycle`, model);
}

export async function deleteCycleAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}

// REMOVE a session from a step
export async function removeSessionFromStepAsync(stepId, sessionId) {
  return await deleteAsync(`${endpoint}/RemoveSessionFromStep/${stepId}/${sessionId}`);
}

export async function getUserSessionsByCycle(userId, cycleId, start, end) {
  // The only place where this is called never use start and end so ....
  // return await getAsync(`${endpoint}/getUserSessionsByCycle/${userId}/${cycleId}/${start}/${end}`);
  return await getAsync(`${endpoint}/getUserSessionsByCycle/${userId}/${cycleId}`);
}